// src/utils/api/Lead/OpenDeals/closeOrderApi.js

const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;


export const closeOrder = async (orderId) => {
    const token = localStorage.getItem('token'); 
  try {
    const response = await fetch(`${API_BASE_URL}/admin/lead/leads/orders/${orderId}/close`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error closing order:', error);
    throw error;
  }
};